<template>
  <div class="wrapper">
    <div class="input">
      <input v-if="type == 'password'" class="left"  :placeholder="hint" v-model="inputValue" type="password"/>
      <input v-else-if="type == 'number'" class="left"  :placeholder="hint" v-model="inputValue" type="number"/>
      <input v-else class="left"  :placeholder="hint" v-model="inputValue" type="text"/>
      <div @click="$emit('click')" v-if="!!rightText" :class="rightStyle == 'normal' ? 'right-normal': 'right-color'">
        {{rightText}}
      </div>
    </div>
    <div class="full-divide"/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    hint: {
      type: String
    },
    rightText: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    rightStyle: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    buttonClass () {
      return {
        'disabled': this.disabled,
        'primary': this.primary,
        'secondary': this.secondary,
        'default': this.default,
        'full-width': this.fullWidth
      }
    }
  },
  watch: {
    value (val) {
      this.inputValue = val
    },
    inputValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleInput (val) {
      this.value = val.target ? val.target.value : val
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.wrapper
  padding-top pt(60)
  .input
    padding-bottom pt(44)
    font-size $normal-font-size
    padding-left pt(10)
    display flex
    justify-content space-between
    .left
      border none
      color $normal-text-color
      flex 1 1 auto
      text-align left
      color $normal-text-color
      padding-right pt(10)
      font-size $normal-font-size
      maxlength 30
      &::placeholder
        color $hint-text-color
        font-size $normal-font-size
      &:focus
        outline none
    .right
      width 5em
      flex 0 1 auto
      text-align right 
      font-size $normal-font-size
      &-normal
        color $normal-text-color
      &-color
        color $primary-color

</style>




// WEBPACK FOOTER //
// input.vue?65e69a6f